import React from "react";
import "../styles/Home.scss";
// import "../styles/body_main.scss";


function Home() {

    return (
        <div className="home">
            <div className="foto_div">
                <img className='foto' alt='' src={require('../media/foto_mono.jpg')} />
            </div>

            <div className="about">
                <div className='name'><p>Aleksei Erastov</p></div>
                <div className='stack'><p>Python Full Stack Web Developer</p>
                    <p>Django | DRF | React | Python</p>
                </div>
            </div>
        </div>
    );
};

export default Home;